import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import type { CompanyTaxAssessment } from "../../../api/client.ts";
import SectionCard from "../../../components/SectionCard.tsx";
import ScrollTable from "../../../components/table/ScrollTable.tsx";
import { formatNumber } from "../../../utils/format.ts";

function amount(value: string | null): string {
  return formatNumber(value == null ? null : Math.round(Number(value)));
}

// Finland publishes each company's taxable income and assessed tax yearly
// (Verohallinto). Taxable income is profit after deductions, not revenue.
export default function TaxAssessmentsCard({
  assessments,
}: {
  assessments: CompanyTaxAssessment[];
}) {
  return (
    <SectionCard title="Corporate income tax">
      <ScrollTable>
        <TableHead>
          <TableRow>
            <TableCell>Tax year</TableCell>
            <TableCell align="right">Taxable income (EUR)</TableCell>
            <TableCell align="right">Tax assessed (EUR)</TableCell>
            <TableCell align="right">Refund</TableCell>
            <TableCell align="right">Residual tax</TableCell>
            <TableCell>Municipality</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {assessments.map((a) => (
            <TableRow key={`${a.source}-${a.tax_year}`}>
              <TableCell>
                {a.tax_year}
                {a.corrected ? " (corrected)" : ""}
              </TableCell>
              <TableCell align="right">{amount(a.taxable_income)}</TableCell>
              <TableCell align="right">{amount(a.taxes_assessed)}</TableCell>
              <TableCell align="right">{amount(a.tax_refund)}</TableCell>
              <TableCell align="right">{amount(a.residual_tax)}</TableCell>
              <TableCell>{a.tax_municipality ?? "-"}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </ScrollTable>
      <Typography variant="caption" sx={{ color: "text.secondary", display: "block", mt: 1 }}>
        Source: Verohallinto, CC BY 4.0
      </Typography>
    </SectionCard>
  );
}
